import React, { useEffect } from 'react';
import cl from './Checkout.module.css';
import CheckoutForm from './CheckoutForm/CheckoutForm';
import { animateScroll as scroll } from 'react-scroll';

const Checkout = (props) => {
  const { cartItems } = props;
  const subTotalPrice = cartItems.reduce((a, c) => a + c.oldPrice * c.qty, 0);
  const totalPrice = cartItems.reduce(
    (a, c) => a + ((c.oldPrice * (100 - c.discount)) / 100) * c.qty,
    0
  );
  const discountPrice = subTotalPrice - totalPrice;

  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.main}>
      <div className={cl.checkout_form}>
        <CheckoutForm />
      </div>
      <div className={cl.cart}>
        <h2 className={cl.header}>Elementi nel Carrello</h2>
        <div>
          {cartItems.length === 0 && (
            <div className={cl.header_empty}>Il Carrello è Vuoto</div>
          )}
          {cartItems.map((item, i) => (
            <div key={i} className={cl.row}>
              <div className={cl.row_img_container}>
                <img src={item.images[0]} alt="item" />
              </div>
              <p>{item.qty} unità</p>
              <div className={cl.name}>{item.name}</div>
              <div className={cl.amount}>
                {item.currency}
                {(
                  item.qty *
                  ((item.oldPrice * (100 - item.discount)) / 100)
                ).toFixed(2)}
              </div>
            </div>
          ))}
        </div>
        {cartItems.length !== 0 && (
          <>
            <hr></hr>
            <div>
              <div className={cl.price}>
                <div>Subtotale</div>
                <div>
                  {' '}
                  {cartItems[0].currency}
                  {subTotalPrice.toFixed(2)}
                </div>
              </div>
              <div className={cl.price}>
                <div>Sconto</div>
                <div>
                  -{cartItems[0].currency}
                  {discountPrice.toFixed(2)}
                </div>
              </div>
              <div className={cl.price_total}>
                <div>Prezzo Totale</div>
                <div>
                  {' '}
                  {cartItems[0].currency}
                  {totalPrice.toFixed(2)}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Checkout;
